module.exports = __webpack_public_path__ + "img/kirurg1.6ef58576.jpg";